import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b70d42b2")

_pushScopeId("data-v-b70d42b2")
const _hoisted_1 = {
  class: "container coupon-logs-page",
  id: "products"
}
const _hoisted_2 = { class: "main-reverse-page-title" }
const _hoisted_3 = {
  class: "d-lg-flex",
  style: {"margin-top":"50px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "coupon-logs-actions order-lg-1 col-lg-2 mb-lg-0 justify-content-center justify-content-lg-center" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "coupon-logs-search col-lg-5 mt-auto" }, null, -1)
const _hoisted_6 = { class: "coupon-logs-summary col-lg-5 mt-auto px-lg-2" }
const _hoisted_7 = {
  class: "coupon-logs-total order-lg-1",
  style: {"height":"48px"}
}
const _hoisted_8 = { class: "coupon-logs-showall align-items-lg-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "coupon-logs-filter-badge"
}
const _hoisted_11 = { class: "coupon-logs-grid-desktop w100" }
const _hoisted_12 = { class: "w100" }
const _hoisted_13 = { class: "coupon-logs-td" }
const _hoisted_14 = { class: "coupon-logs-td" }
const _hoisted_15 = { class: "coupon-logs-td" }
const _hoisted_16 = { class: "coupon-logs-td" }
const _hoisted_17 = { class: "coupon-logs-td" }
const _hoisted_18 = { class: "coupon-logs-td" }
const _hoisted_19 = { class: "coupon-logs-td" }
const _hoisted_20 = { class: "coupon-logs-td" }
const _hoisted_21 = { class: "coupon-logs-td" }
const _hoisted_22 = {
  key: 0,
  class: "coupon-logs-grid-mobile"
}
const _hoisted_23 = { class: "mobile-table-info-card" }
const _hoisted_24 = { class: "coupon-logs-card-row" }
const _hoisted_25 = { class: "coupon-logs-card-row" }
const _hoisted_26 = { class: "coupon-logs-card-row" }
const _hoisted_27 = { class: "coupon-logs-card-row" }
const _hoisted_28 = { class: "coupon-logs-card-row" }
const _hoisted_29 = { class: "coupon-logs-card-row" }
const _hoisted_30 = { class: "coupon-logs-card-row" }
const _hoisted_31 = { class: "coupon-logs-card-row" }
const _hoisted_32 = { class: "coupon-logs-card-row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toast = _resolveComponent("Toast")
  const _component_CouponLogsFilterModal = _resolveComponent("CouponLogsFilterModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('navbar.coupon-logs')), 1),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('coupon-logs.total-logs')) + ":", 1),
          _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('coupon-logs.of', { total: _ctx.total })), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
          }, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]),
        _createVNode("div", {
          class: ["coupon-logs-filter", { hasFilter: _ctx.hasFilter }]
        }, [
          _createVNode("button", {
            type: "button",
            class: "coupon-logs-filter-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goCouponLogsFilter()))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
            _hoisted_9
          ]),
          (_ctx.hasFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_10, "!"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("table", _hoisted_12, [
        _createVNode("thead", null, [
          _createVNode("tr", null, [
            _createVNode("td", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortBy('ExternalSystem')))
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('coupon-logs.external-system')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ExternalSystem')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortBy('Action')))
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('label.action')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Action')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortBy('CreatedAt')))
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('label.create-date')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CreatedAt')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortBy('Status')))
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('title.status')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Status')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortBy('ProviderId')))
            }, [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('label.provider_id')) + " ", 1),
                _createVNode("i", {
                  class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProviderId')]
                }, null, 2)
              ])
            ]),
            _createVNode("td", null, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('orders.orderNumber')), 1)
            ]),
            _createVNode("td", null, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('coupons.code')), 1)
            ]),
            _createVNode("td", null, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('coupon-logs.request-data')), 1)
            ]),
            _createVNode("td", null, _toDisplayString(_ctx.$t('coupon-logs.response-data')), 1)
          ])
        ]),
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.logs, (log) => {
            return (_openBlock(), _createBlock("tr", {
              key: log.id,
              style: {"position":"relative"}
            }, [
              _createVNode("td", _hoisted_13, _toDisplayString(_ctx.couponSystem[log.externalSystemType]), 1),
              _createVNode("td", _hoisted_14, _toDisplayString(_ctx.couponAction[log.action]), 1),
              _createVNode("td", _hoisted_15, _toDisplayString(log.createdAt), 1),
              _createVNode("td", _hoisted_16, _toDisplayString(_ctx.couponLogStatus[log.status]), 1),
              _createVNode("td", _hoisted_17, _toDisplayString(log.providerId), 1),
              _createVNode("td", _hoisted_18, _toDisplayString(log.orderNumber), 1),
              _createVNode("td", _hoisted_19, _toDisplayString(log.couponCode), 1),
              _createVNode("td", _hoisted_20, [
                _createVNode("button", {
                  class: "coupon-log-view-btn",
                  type: "button",
                  onClick: ($event: any) => (_ctx.copyAndToast(log.requestData))
                }, _toDisplayString(_ctx.$t('button.copy')), 9, ["onClick"])
              ]),
              _createVNode("td", _hoisted_21, [
                _createVNode("button", {
                  class: "coupon-log-view-btn",
                  type: "button",
                  onClick: ($event: any) => (_ctx.copyAndToast(log.responseData))
                }, _toDisplayString(_ctx.$t('button.copy')), 9, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.logs && _ctx.logs.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_22, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.logs, (log, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "coupon-logs-card",
              key: index
            }, [
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('coupon-logs.external-system')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.couponSystem[log.externalSystemType]), 1)
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('label.action')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.couponAction[log.action]), 1)
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('label.create-date')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(log.createdAt), 1)
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('title.status')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.couponLogStatus[log.status]), 1)
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('label.provider_id')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(log.providerId), 1)
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('orders.orderNumber')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(log.orderNumber), 1)
                ]),
                _createVNode("div", _hoisted_30, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('coupons.code')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(log.couponCode), 1)
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('coupon-logs.request-data')) + ": ", 1),
                  _createVNode("button", {
                    class: "coupon-log-view-btn",
                    type: "button",
                    onClick: ($event: any) => (_ctx.copyAndToast(log.requestData))
                  }, _toDisplayString(_ctx.$t('button.copy')), 9, ["onClick"])
                ]),
                _createVNode("div", _hoisted_32, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('coupon-logs.response-data')) + ": ", 1),
                  _createVNode("button", {
                    class: "coupon-log-view-btn",
                    type: "button",
                    onClick: ($event: any) => (_ctx.copyAndToast(log.responseData))
                  }, _toDisplayString(_ctx.$t('button.copy')), 9, ["onClick"])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Toast, { position: "top-center" }),
    _createVNode(_component_CouponLogsFilterModal, {
      onApplyFilter: _ctx.applyFilter,
      ref: "modalCouponLogsFilter"
    }, null, 8, ["onApplyFilter"])
  ]))
})